module.exports = __webpack_public_path__ + "img/del_img.8d597e55.png";